module.exports = __webpack_public_path__ + "media/Images/icon-playbook-red-o-1934c9aa7192c5caabd4b1f155ef36f7.svg";